import React from "react"
import { Col, Row, Form, Dropdown } from "react-bootstrap"
import { Field, getIn } from "formik"
import FormLabel from "../formLabel"

function FeedbackFormTextArea(props) {
    const { textDesc, form, field, maxLength, toUpperCase, noticeArray } = props

    const errorsMsg = getIn(form.errors, field.name)
    // const touched = getIn(form.touched, field.name)

    const inputErrorClassName = (touched, errors, inputName) => {
        //  (clickedNext && errors[inputName]) ||
        return errors[inputName] && touched[inputName] ? "is-invalid" : null
    }

    const inputErrorMessage = (touched, errors, inputName) => {
        return errors[inputName] && touched[inputName] ? (
            <span className="InputError">{errorsMsg}</span>
        ) : null
    }

    return (
        <Form.Group>
            <Row>
                <Col xs={12} md={6} className="marginTop10px marginLeftRightAuto">
                    <Field
                        name={field.name}
                        as="textarea"
                        placeholder="Thank you for your rating!
                        Tell us more about your experience!"
                        className={
                            "d-block textareabox textAlignCenter " +
                            inputErrorClassName(form.touched, form.errors, field.name)
                        }
                        type="text"
                        onChange={event => {
                            let value = event.target.value || ""
                            if (toUpperCase) {
                                value = value.toUpperCase()
                            }
                            form.setFieldValue(field.name, value)
                        }}
                        onBlur={event => {
                            form.handleBlur(event)

                            let value = event.target.value || ""
                            if (toUpperCase) {
                                value = value.toUpperCase()
                            }
                            form.setFieldValue(field.name, value.trim()) // Trim field value when blur
                        }}
                        maxLength={maxLength}
                        autoComplete="new-password"
                        value={
                            toUpperCase
                                ? field.value.toUpperCase()
                                : field.value
                                    ? field.value
                                    : ""
                        }
                    />
                    {inputErrorMessage(form.touched, form.errors, field.name)}
                </Col>
            </Row>
        </Form.Group >
    )
}

export default FeedbackFormTextArea
